export enum BookingTypeEnum {
  ADD = 'Zubuchung',
  SUBSTRACT = 'Abbuchung',
  MOVE = 'Umbuchung'
}
